import { mergeStyleSets, Stack, Text } from '@fluentui/react';
import dateFormat from 'dateformat';

import { theme } from '../../utils/theme';
import Item, { CalendarItemInfo } from './Item';

export type CalendarCellProps = {
  date: Date;
  items: (CalendarItemInfo | null)[];
};

export default (props: CalendarCellProps) => {
  const isToday = props.date.getTime() === today.getTime();

  return (
    <div
      className={`${styles.root} ${
        isToday
          ? styles.blueBackground
          : [0, 6].includes(props.date.getDay())
          ? styles.grayBackground
          : ""
      }`}
    >
      <div className={styles.body}>
        <Stack className={styles.container}>
          <Text variant="large">
            {isToday ? "Bugün" : dateFormat(props.date, "d mmm")}
          </Text>
          <div>
            <hr />
          </div>
          <Stack tokens={{ childrenGap: 5 }}>
            {props.items.map((item, index) => (
              <div className={styles.itemSpace}>
                {item ? (
                  <Item key={index} itemInfo={item} date={props.date} />
                ) : (
                  <>&nbsp;</>
                )}
              </div>
            ))}
          </Stack>
        </Stack>
      </div>
    </div>
  );
};

const today = new Date();
today.setHours(0, 0, 0, 0);
const styles = mergeStyleSets({
  root: {
    width: "14.285%",
    minHeight: "100px",
  },
  body: {
    width: "calc(100% - 1px)",
    height: "calc(100% - 1px)",
    border: `1px solid ${theme.palette.neutralTertiary}`,
  },
  container: {
    padding: "6px",
  },
  itemSpace: {
    height: "32px",
  },
  grayBackground: {
    backgroundColor: theme.palette.neutralLight,
  },
  blueBackground: {
    backgroundColor: theme.palette.themeLighterAlt,
  },
});
